<template>
	<div>
		<language :name="languages[0].name" :code="languages[0].code"></language>
		<language :name="languages[1].name" :code="languages[1].code"></language>
	</div>
</template>

<script>
import Vue from 'vue'
export default {
	data () {
		return {
			lang: Vue.config.lang,
			languages: [
				{
					code: 'kr',
					name: '한국어'
				},
				{
					code: 'en',
					name: 'English'
				}
			]
		}
	},
	components: {
		language: {
			props: ['code', 'name'],
			template: '<p @click="Select">{{ name }}</p>',
			methods: {
				Select (e) {
					//console.log('code ' + this.code)
					//Vue.config.lang = this.code
					this.$i18n.locale = this.code
				}
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/LanguageChooser.vue